import { Link } from "react-router-dom";

// Talabalar bo'limi sahifalari uchun umumiy sarlavha
function StudentHeader({ title, crumb }) {
    return (
        <section className="page-header">
            <div className="container">
                <div className="page-header__content">
                    <ul className="eduhive-breadcrumb list-unstyled">
                        <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                        <li><Link to="/students">Talabalar uchun</Link></li>
                        <li><span>{crumb}</span></li>
                    </ul>
                    <h2 className="page-header__title">{title}</h2>
                </div>
            </div>
        </section>
    );
}

export default StudentHeader;
